import React, { useContext, useMemo, useState } from 'react';
import { Link } from 'react-router';
import MenuIcon from '@mui/icons-material/Menu';
import TransparentIconButton from '../buttons/TransparentIconButton';
import { Drawer } from '@mui/material';
import { getRoutesForRestaurant, pageRoutes } from '../../config/routeConfig';
import LogoutIcon from '@mui/icons-material/Logout';
import AuthContext from '../../contexts/AuthContext';
import MobileHeaderRow from './MobileHeaderRow';
import MobileHeaderButton from './MobileHeaderButton';
import CloseIcon from '@mui/icons-material/Close';
import { RightType } from '../../models/Auth';

export default function MobileHeader() {
    const { logout, tableManagementOn, userInfo, myRestaurants, selectRestaurant } = useContext(AuthContext);
    const [menuOpen, setMenuOpen] = useState(false);

    const displayedPages = useMemo(() => {
        if (userInfo == null || userInfo.selected_restaurant == null) return [];
        return getRoutesForRestaurant(
            tableManagementOn, 
            userInfo?.selected_restaurant.group_reservations, 
            userInfo?.selected_restaurant.waitlist,
            userInfo?.right_type as RightType,
        );
    }, [tableManagementOn, userInfo?.selected_restaurant]);

    return (
        <div className="bg-primary-dark text-white h-14 flex justify-between items-center p-4">
            <Link to="/">
                <img
                    src="/assets/logo.png"
                    className="w-3/4"
                />
            </Link>
            <h1 className='text-center'>{"ReservOurs"}</h1>
            <TransparentIconButton onClick={() => setMenuOpen(true)}>
                {menuOpen ? <CloseIcon fontSize={"large"} /> : <MenuIcon fontSize={"large"} />}
            </TransparentIconButton>
            <Drawer
                anchor='right'
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                PaperProps={{
                    className: 'mt-14 w-full'
                }}
                ModalProps={{
                    BackdropProps: {
                        invisible: true, // Eltávolítja a háttér elsötétítését
                    },
                    keepMounted: false
                }}
            >
                <div className="h-full w-full bg-primary-dark text-white flex flex-col gap-2 p-4">
                    {displayedPages.map(route => (
                        <MobileHeaderRow
                            key={route.title}
                            title={route.headerTitle}
                            icon={route.icon}
                            route={route.path}
                            onClick={() => setMenuOpen(false)}
                        />
                    ))}
                    <MobileHeaderButton
                        icon={<LogoutIcon />}
                        title={"logout"}
                        onClick={() => logout()}
                    />
                </div>
            </Drawer>
        </div>
    );
}